module.exports = __webpack_public_path__ + "img/hion_32.5368d366.jpg";